module.exports = __webpack_public_path__ + "static/media/move-in-house-w-blue-bground-icon.66ed9d1a.svg";